/** Configuration, runtime status and diagnostic links for System & Betrieb. */

import { Trans } from '@lingui/react/macro';
import type { ReactNode } from 'react';

import SettingsPanel from '../admin/SettingsPanel';

import AdvisoryTemplateCard from './AdvisoryTemplateCard';
import BrandingCard from './BrandingCard';
import ReportingSettingsCard from './ReportingSettingsCard';

export function SystemOverviewPage(): ReactNode {
  return (
    <>
      <SettingsPanel />

      <ReportingSettingsCard />

      <AdvisoryTemplateCard />

      <BrandingCard />

      <div className="card">
        <div className="card-head">
          <h2><Trans>Weitere Oberflächen</Trans></h2>
        </div>
        <div className="card-body">
          {/*
            Server-rendered surfaces outside the SPA — plain anchors, in a new
            tab so the current console state survives.
          */}
          <div className="ops-links">
            <a href="/legacy/dashboard" target="_blank" rel="noreferrer">
              <Trans>Legacy-Dashboard</Trans>
            </a>
            <a href="/legacy/import" target="_blank" rel="noreferrer">
              <Trans>Legacy-Import</Trans>
            </a>
            <a href="/docs" target="_blank" rel="noreferrer">
              <Trans>API-Dokumentation</Trans>
            </a>
            <a href="/health" target="_blank" rel="noreferrer">
              <Trans>Health-Endpunkt</Trans>
            </a>
          </div>
        </div>
      </div>
    </>
  );
}

export default SystemOverviewPage;
